// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__L_sCV","additionalInfo":"AgreementModal_additionalInfo__37V5f"};